import DependencyViewModel from '@src/mobx-store/vm/dependency-view-model';

class ViewModel extends DependencyViewModel {}

const VM = ViewModel;
export default VM;



// WEBPACK FOOTER //
// ./src/mobx-store/vm/view-model.js